// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__LbVhF","footer":"ModalUpdate_footer__2y_5M"};